import React, { useEffect, useState } from 'react'
import { IconButton, Icon } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { isSomeBoxEdit } from '../../../utils/widget'
import PopupModal from '../../modal/PopupModal'
import { getPreviousProjectVersionId } from '../../../redux/actions/projectOverview'

export default function ViewPreviousVersionButon({
  handleGetSchemaPrevious = () => {},
  isViewPrevious,
  masterSubjectId
}) {
  const history = useHistory()

  const [previousProjectVersionId, setPreviousProjectVersionId] = useState(false)

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (projectId) {
      handleGetPermission(projectId)
    }
  }, [])

  const handleGetPermission = async (projectId) => {
    try {
      const response = await getPreviousProjectVersionId(projectId, masterSubjectId)
      setPreviousProjectVersionId(response.previousProjectVersionId)
    } catch (e) {
      console.log('e', e)
    }
  }

  return (
    <>
      {previousProjectVersionId && (
        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
          <IconButton
            appearance="ghost"
            className={isViewPrevious ? "rs-btn-ghost-cancel" : "rs-btn-ghost-info"}
            style={{ marginRight: '3px' }}
            icon={<Icon className={isViewPrevious ? "bt-gost-icon-radius-cancel" : "bt-gost-icon-radius-info"} icon={isViewPrevious ? "eye-slash" : "eye"} />}
            onClick={() =>{
              handleGetSchemaPrevious(previousProjectVersionId)

            }}
          >
            {isViewPrevious ? 'ซ่อนประวัติการแก้ไข' : 'ดูประวัติการแก้ไข'}
          </IconButton>
        </div>
      )}
    </>
  )
}
